import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';

const ConditionalTooltip = ({ visible, title, children }) => {
  return visible ? (
    <Tooltip title={title}>
      {children}
    </Tooltip>
  ) : (
    children
  );
};

export default ConditionalTooltip;